import { Tactic } from "../../../redux/tactics/tacticsSlice";
import axios from "../../api";

export const getTacticFromCode = async ({ code }: { code: string }) => {
  const encodedCode = encodeURIComponent(code);
  const res = await axios.get<Tactic>(
    `/tactics/get-tactic-from-code/${encodedCode}?v=2`,
  );
  return res.data;
};
